// eslint-disable-next-line import/no-extraneous-dependencies
import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: 'https://df1ec081dc214277935f8520a03bdc57@o1223220.ingest.sentry.io/6376167',
  environment: process.env.SENTRY_ENV,
  release: process.env.BITBUCKET_COMMIT,
  enabled: process.env.BITBUCKET_COMMIT !== undefined,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  sampleRate: 1,
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});
